import { GetterTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { PEDIDO } from "./types";

type PedidoCompletosGetterTree = GetterTree<PEDIDO, RootState>;

export const getters: PedidoCompletosGetterTree = {
  
};
